import { Box, Typography, IconButton, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import { API_Q_MEDALS_IMAGE } from "../../../../constants/api";
import classes from "./MedalInfo.module.scss";
import AButtonGamePlay from "../AButtonGamePlay/AButtonGamePlay";
import { useMedalInfoLogic } from "./useMedalInfoLogic";


const MedalInfoDesktop = ({medal, modalRef, setOpenGame, activity }) => {
  
  const { isMedalComplete, MedalConditions, getImageStyles, getStars } =
    useMedalInfoLogic({ medal });
  
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (medal) {
      setContent(
        <Box
          sx={{
            height: "714px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            padding: "10px",
            paddingLeft: "30px",
          }}
        >
          <Grid container spacing={6} alignItems="flex-start">
            {/* Grid item para o conteúdo */}
            <Grid item size={{ xs: 12, md: 6 }} order={{ xs: 2, md: 1 }}>
              <Box
                sx={{
                  textAlign: "left",
                  padding: "10px",
                  marginBottom: "30px",
                }}
              >
                <Typography
                  dangerouslySetInnerHTML={{ __html: medal?.description }}
                  sx={{
                    textAlign: "left",
                    marginBottom: "20px",
                    color: "#666666",
                    "& li": {
                      marginBottom: "8px",
                      listStyleType: "disc",
                      marginLeft: "20px",
                    },
                  }}
                />
                <Typography sx={{ textAlign: "left", color: "#666666" }}>
                  <Typography
                    dangerouslySetInnerHTML={{ __html: medal?.goals }}
                    sx={{ marginBottom: "20px" }}
                  />
                  <MedalConditions
                    conditions={medal?.conditions}
                    max_level={medal?.max_level}
                  />
                </Typography>
              </Box>
            </Grid>

            {/* Grid item para a imagem */}
            <Grid
              item
              size={{ xs: 12, md: 6 }}
              order={{ xs: -1, sm: -1, md: 1, lg: 1, xl: 1 }}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "column" },
                alignItems: "center",
                justifyContent: {
                  xs: "center",
                  md: "flex-start",
                  lg: "flex-end",
                },
              }}
            >
              <Box
                className={classes.BwModal}
                sx={{
                  marginBottom: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  className={classes.Image}
                  src={`${API_Q_MEDALS_IMAGE}/${medal?.image}`}
                  alt={medal?.title}
                  style={getImageStyles(medal?.conditions)}
                />
              </Box>
              <Box>
                <AButtonGamePlay onClick={() => setOpenGame(activity)} />
              </Box>
            </Grid>
          </Grid>

          <Box className={classes.ColorModal}>
            {getStars(medal?.max_level, medal?.conditions)}
          </Box>
        </Box>
      );
    }
  }, [medal]);

  return content;
};

export default MedalInfoDesktop;
